var map = {
	"./Arrow.svg": 221,
	"./BucketIcon.svg": 222,
	"./Cascade.svg": 223,
	"./CashgameIcon.svg": 224,
	"./Close.svg": 225,
	"./DecSort.png": 226,
	"./EntryIcon.svg": 227,
	"./Flat.svg": 228,
	"./GoldCoin.png": 229,
	"./LeftArrow.svg": 230,
	"./Link.svg": 231,
	"./LobbyUrl1.png": 232,
	"./LocationEnable.png": 233,
	"./NLHGameType.png": 234,
	"./NLHGameTypeVerical.png": 235,
	"./P52_Circular.svg": 236,
	"./PCImg.svg": 237,
	"./PLO5GameType.png": 238,
	"./PLO5GameTypeVertical.png": 239,
	"./PLOGameType.png": 240,
	"./PLOGameTypeVertical.png": 241,
	"./PinCopy.svg": 242,
	"./PrefunCheckBox.svg": 243,
	"./PrizePoolImg.png": 244,
	"./Refresh.svg": 245,
	"./RightArrow.svg": 246,
	"./Tablepokerweb.png": 247,
	"./TicketActive.svg": 248,
	"./TicketImg.svg": 249,
	"./Tile.svg": 250,
	"./ToggleOFF.svg": 251,
	"./ToggleON.svg": 252,
	"./activeRadioIcon.svg": 253,
	"./add-icon.svg": 254,
	"./allInCover.png": 255,
	"./banner-left-arrow.svg": 256,
	"./banner-right-arrow.svg": 257,
	"./betSettings.svg": 258,
	"./blackStarIcon.svg": 259,
	"./blueDiamond.svg": 260,
	"./bonus-icon.svg": 261,
	"./bonusGiftIcon.svg": 262,
	"./break.svg": 263,
	"./cashGameTicketEmpty.svg": 264,
	"./cashTicketCalenderIcon.png": 265,
	"./cashTicketImage.svg": 266,
	"./cashTopupTicketActive.svg": 267,
	"./cashTopupTicketInactive.svg": 268,
	"./cashgame-inactive.svg": 269,
	"./casino-chipsIcon.svg": 270,
	"./champagne.svg": 271,
	"./chat.svg": 272,
	"./chatActive.svg": 273,
	"./checkered-flag.svg": 274,
	"./club.png": 275,
	"./clubs_green.png": 276,
	"./coin-stack.svg": 277,
	"./coming_soon_new.png": 278,
	"./commissionBalanceTransferedIcon.png": 279,
	"./commissionBalanceTransferringIcon.svg": 280,
	"./created.svg": 281,
	"./dealer.svg": 282,
	"./dealerButton.svg": 283,
	"./decrease.svg": 284,
	"./diamond.png": 285,
	"./diamond_blue.png": 286,
	"./diwaliPokerBG.jpg": 287,
	"./diwaliTable.png": 288,
	"./diwaliTableMweb.png": 289,
	"./down-arrow.svg": 290,
	"./dropDownArrow.png": 291,
	"./facebook.svg": 292,
	"./favicon.png": 293,
	"./featuredTourn.svg": 294,
	"./fileIcon.svg": 295,
	"./filterActiveIcon.svg": 296,
	"./filterInActiveIcon.svg": 297,
	"./filterPopup_checkedBox.svg": 298,
	"./filterPopup_unCheckBox.svg": 299,
	"./flag.svg": 300,
	"./foldPlaying.svg": 301,
	"./gameSettings.svg": 302,
	"./goldStarIcon.svg": 303,
	"./greenClub.svg": 304,
	"./handRepMute.svg": 305,
	"./handRepNext.svg": 306,
	"./handRepPause.svg": 307,
	"./handRepPlay.svg": 308,
	"./handRepStop.svg": 309,
	"./handReplay.svg": 310,
	"./handReplayLeftArrow.svg": 311,
	"./handReplayerCalendar.svg": 312,
	"./header_logo.png": 148,
	"./header_logo.svg": 313,
	"./hearts.png": 314,
	"./help-icon.svg": 315,
	"./helpdeskIcon.svg": 316,
	"./helpdesk_chatbubbleIcon.svg": 317,
	"./helpdesk_crossIcon.svg": 318,
	"./helpdesk_mailIcon.svg": 319,
	"./helpdesk_phoneIcon.svg": 320,
	"./horizonalRotate.png": 321,
	"./inActiveBetSettings.svg": 322,
	"./inActiveGameSettings.svg": 323,
	"./inActiveRadioIcon.svg": 324,
	"./increase.svg": 325,
	"./infoCircularIcon.svg": 326,
	"./infoIcon.svg": 327,
	"./joinSimilar.svg": 328,
	"./learnMoreInfo.png": 329,
	"./leaveTableIcon.svg": 330,
	"./linkIcon.svg": 331,
	"./livePlayersIcon.png": 332,
	"./lobbyBack.svg": 333,
	"./lobbyBurger.png": 334,
	"./lobbyIcon.svg": 335,
	"./lock.svg": 336,
	"./menu.svg": 337,
	"./menuChip.png": 338,
	"./mobileLeaveSeatIcon.svg": 339,
	"./mobileLobby.png": 340,
	"./mobileSettingsIcon.svg": 341,
	"./moreIcon.svg": 342,
	"./mwebDepositIcon.svg": 343,
	"./mwebEarnMore.svg": 344,
	"./mwebTableWide.png": 345,
	"./mwebVendorWallet.svg": 346,
	"./noData.svg": 347,
	"./notes.svg": 348,
	"./notes_active.svg": 349,
	"./p52_table_maxButton.svg": 350,
	"./p52_table_minButton.svg": 351,
	"./parkTickets.svg": 352,
	"./pin.svg": 353,
	"./pinBig.svg": 354,
	"./playerDefaultDP.png": 355,
	"./playingCards.svg": 356,
	"./pocketCoins.svg": 357,
	"./pogCoins.svg": 358,
	"./pokerBackCards.svg": 359,
	"./pokerChip.svg": 360,
	"./pokerTableBackground.png": 361,
	"./pokerTableColoredIcon.svg": 362,
	"./pokerTableInfo.png": 363,
	"./pokerTableSettings.png": 364,
	"./poker_table_icon.svg": 365,
	"./preCheckBox.svg": 366,
	"./privateTableIcon_active.svg": 367,
	"./privateTableIcon_inactive.svg": 368,
	"./prizeIcon.svg": 369,
	"./profile-user.svg": 370,
	"./prohibition.svg": 371,
	"./reEntryTimer.svg": 372,
	"./rsicon.svg": 373,
	"./rupee.svg": 374,
	"./rupeeCoinIcon.svg": 375,
	"./rupeesCallectionIcon.svg": 376,
	"./satelliteIcon.svg": 377,
	"./searchIcon.svg": 378,
	"./seatTimer.svg": 379,
	"./send.svg": 380,
	"./share.svg": 381,
	"./sidebar_handHistory_inactive.svg": 382,
	"./sidebar_liveUserIcon.svg": 383,
	"./sidebar_lobby_active.svg": 384,
	"./sidebar_lobby_inactive.svg": 385,
	"./sidebar_profile_active.svg": 386,
	"./sidebar_profile_disable.svg": 387,
	"./sidebar_ranking_inactive.svg": 388,
	"./sidebar_settings_active.svg": 389,
	"./sidebar_settings_inactive.svg": 390,
	"./sidebar_vault.svg": 391,
	"./sidebar_wallet_disable.svg": 392,
	"./sitHereArrow.svg": 393,
	"./small_crossIcon.svg": 394,
	"./sngActive.svg": 395,
	"./sngInActive.svg": 396,
	"./sorting_decreasing_icon.svg": 397,
	"./sorting_default_icon.svg": 398,
	"./sorting_increasing_icon.svg": 399,
	"./soundIcon.svg": 400,
	"./spade.png": 401,
	"./starIcon.svg": 402,
	"./stats.svg": 403,
	"./stopwatchBorderIcon.svg": 404,
	"./stopwatchIcon.svg": 405,
	"./tableTopup.svg": 406,
	"./teaCupIcon.svg": 407,
	"./telegramLogo.png": 408,
	"./ticketGreenIcon.svg": 409,
	"./timer.svg": 410,
	"./toggleBetInactive.svg": 411,
	"./toggleDirectbet.svg": 412,
	"./topUpIcon.svg": 413,
	"./topupCheckbox.svg": 414,
	"./topupCheckboxInactive.svg": 415,
	"./tournament-active.svg": 416,
	"./tournamentCoins.svg": 417,
	"./transferArrow.svg": 418,
	"./transferIcon.png": 419,
	"./unjoinTimer.svg": 420,
	"./user-icon.svg": 421,
	"./usersColoredIcon.svg": 422,
	"./verticalRotate.png": 423,
	"./waitListTableIcon.svg": 424,
	"./walletActiveIcon.svg": 425,
	"./warningIcon.svg": 426,
	"./wavingHandIcon.png": 427,
	"./whatsapp.svg": 428,
	"./wifiMedium.svg": 149,
	"./wifiSymbol.svg": 150,
	"./wifiWeak.svg": 151,
	"./winnersIcon.png": 429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;